export const verifyBooleanString = (value, boolean) => value === boolean
